export enum PaymentTypeEnum {
  HiProTransfer = 'hi_pro_transfer',
  InternalTransfer = 'internal_transfer',
  OnlineTransfer = 'online_transfer',
  TraditionalTransfer = 'traditional_transfer',
}
